<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      „პრო ბონო“ - ანუ საზოგადოებისთვის სასარგებლო საქმიანობა
    </h1>
    <h6>სექტემბერი 2023</h6>
    <br />

    <p>
      ადამიანს უნდა და სჭირდება იყოს საზოგადოების სრულფასოვანი წევრი, რაც ხშირად სოციალური ცხოვრებისა თუ
      პასუხისმგებლობის ფარგლებს სცდება და საკუთარ წილ „სასარგებლო საქმიანობაში“ ითარგმნება. რა შეედრება კმაყოფილების
      გრძნობას, რომელსაც სხვებზე ზრუნვისას განვიცდით? იქნება ეს მოხუცის დახმარება გზის გადაკვეთისას, ორსულისთვის ადგილის
      დათმობა საზოგადოებრივ ტრანსპორტში თუ ისეთი მარტივი, მაგრამ მნიშვნელოვანი აქტი, როგორიც უცხოსთვის კარის გაღებაა?
      სხვათა შორის, წლების წინ აშშ-ში მცირე ბიზნესის მხარდასაჭერი საინტერესო სარეკლამო ბანერები გამოჩნდა, წარწერებით
    </p>

    <p>
      <b class="blue" style="font-size: 26px;">
        „როცა ბაზარში ფერმერისგან ყიდულობ, მისი შვილის ბედნიერების ცეკვას, საყვარელი გუნდის მაისურის შეძენასა და სწავლის
        გადასახადს აფინანსებ.“
      </b>
    </p>

    <img src="../../../../assets/blog/pro-bono/img1.jpg" alt="" />

    <p>
      თანამედროვე ცხოვრების რიტმი ისეთ გამოწვევებს გვთავაზობს, რომ რთულია დრო სამსახურს, ოჯახს, მეგობრებს,
      თვითგანვითარებას და სოციალურ აქტიურობას თანაბრად გადაუნაწილო. დღის ბოლოს ჩნდება კითხვა „აბა მე დღეს ვის რა
      ვარგე?!“ და მთელი სიმძაფრით გვახსენებს იმას, რომ „მეტი შეგიძლია, მაგრამ რესურსი არ გყოფნის“.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-blue">
      <div class="container">
        <p class="bold-text capitalized-text">
          პრო-ბონო, რაც ლათინურიდან „ საზოგადოებისთვის სასარგებლო საქმიანობად“ ითარგმნება, სწორედ ამ პრობლემას აგვარებს.
          შენ შეგიძლია საკუთარი უნარებით, პროფესიონალიზმით, ინტელექტუალური შესაძლებლობებით დაეხმარო მას, ვისაც ეს ასე
          სჭირდება.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      სტარტაპი, მცირე ბიზნესი თუ ინდივიდუალური მეწარმე, განვითარების გარკვეულ საფეხურზე ექსპერტულ მიდგომებს საჭიროებს,
      რაც რამდენი ადამიანისგან შემდგარ გუნდში დიდი გამოწვევაა. შეზღუდული მატერიალური რესურსებიდან გამომდინარე,
      სხვადასხვა დარგის სპეციალისტისთვის მიმართვა ნამდვილი „ფუფუნებაა“, თუმცა არა „პრო-ბონო“ ჩართულობით. ინიციატივის
      გარშემო ისედაც არიან გაერთიანებული ადამიანები, რომელთაც აქვთ სურვილი გაგიწიონ პროფესიონალური დახმარება.
    </p>

    <p>
      და რადგან კომპანიებისათვის პრო ბონო სერვისები მათი სოციალური პასუხისმგებლობის განხორციელების ერთ-ერთ ფორმას,
      კერძოდ კი, თანამშრომელთა მოხალისეობის (კორპორაციული მოხალისეობის) ერთ-ერთ ფორმას წარმოადგენს, CSRDG მედიაციით
      ჩვენც აქტიურად ჩავერთეთ ინიციატივაში.
    </p>

    <p>
      თანამშრომლებს შორის ინფორმაციის გავრცელებიდან რამდენიმე საათში უკუკავშირი მივიღეთ, ამ ეტაპზე შეთავაზებულ ორ
      პროექტში ჩართვის სურვილი 60%-მა გამოთქვა, რის შემდეგაც სოციალურ საწარმო „პოტერიასთან“, ისევე როგორც სათემო კავშირ
      „ანა-ბანასთან“ შეხვედრები ჩავნიშნეთ. პირველ ეტაპზე, მოვისმინეთ საჭიროებები, განვსაზღვრეთ სამოქმედო გეგმა და საქმეს
      შევუდექით.
    </p>

    <img src="../../../../assets/blog/pro-bono/img2.jpg" alt="" />

    <p>
      <b class="blue" style="font-size: 26px;">
        სათემო კავშირი „ანა-ბანა“ ლაგოდეხში სამკითხველო სივრცის და ბიბლიოთეკის გაკეთებაში საჭიროებდა დახმარებას,
        რისთვისაც თიბისი ლიზინგის მასშტაბით წიგნების აგროვება დავიწყეთ, დამატებით ათეულობით წიგნი შევისყიდეთ და
        თანამშრომლებთან ერთად გადავეცით.
      </b>
    </p>

    <img src="../../../../assets/blog/pro-bono/img3.jpg" alt="" />

    <p>
      რაც შეეხება
      <b class="blue" style="font-size: 26px;">
        „პოტერიას“ - საწარმოს სოციალური მისია კანონთან კონფლიქტში მყოფი და ძალადობა გამოვლილი ქალების საზოგადოებაში
        რეინტეგრაციის ხელშეწყობა, ახალი პროფესიის ათვისებითა და შემოქმედებით სახელოსნოში დასაქმების მეშვეობით.
      </b>
    </p>

    <p>
      ამ ეტაპზე მათთვის პრიორიტეტული კორპორაციული შეთავაზებების დამზადება და გაყიდვების ზრდაა, რაშიც აქტიურად ჩავერთეთ
      და მასტერკლასში მონაწილეობის მისაღებად თავადაც ვესტუმრეთ.
    </p>

    <p>
      დღეისთვის სულ ეს იყო, სამომავლოდ ვეცდებით ამ საინტერესო ინიციატივებსა და კომპანიებზე კიდევ უფრო მეტი მოგიყვეთ.
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      „Pro bono“ - that is, activities for the benefit of society
    </h1>
    <h6>September 2023</h6>
    <br />

    <p>
      A person needs to and should be a full member of society, which often goes beyond the limits of social life or
      responsibility and translates into their share of "useful activities." What compares to the feeling of
      satisfaction we experience when caring for others? Whether it's helping an elderly person cross the street,
      offering a seat to a pregnant woman on public transport, or such a simple yet significant act as opening the door
      for a stranger? By the way, several years ago, interesting advertising banners appeared in the USA to support
      small businesses, with slogans:
    </p>

    <p>
      <b class="blue" style="font-size: 26px;">
        „When you buy from a farmer at the market, you are financing his child's happy dance, buying his favorite team's
        jersey, and paying for his education.“
      </b>
    </p>

    <img src="../../../../assets/blog/pro-bono/img1.jpg" alt="" />

    <p>
      The rhythm of modern life presents such challenges that it is difficult to distribute time equally between work,
      family, friends, personal development, and social activity. At the end of the day, the question arises, "What have
      I done for whom today?!" and it sharply reminds us that "you can do more, but you don't have enough resources."
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-blue">
      <div class="container">
        <p class="bold-text capitalized-text">
          Pro bono, which translates from Latin as "activities for the benefit of society," addresses this problem. You
          can use your skills, professionalism, and intellectual abilities to help those who need it most.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      A startup, small business, or individual entrepreneur at a certain stage of development needs expert approaches,
      which is a big challenge in a team of a few people. Due to limited financial resources, consulting with
      specialists from different fields is a true "luxury," but not with pro bono involvement. People are already united
      around the initiative, who are willing to provide professional assistance.
    </p>

    <p>
      And since pro bono services for companies are one of the forms of their social responsibility, specifically one
      form of employee volunteering (corporate volunteering), through CSRDG mediation, we actively participated in the
      initiative.
    </p>

    <p>
      A few hours after spreading the information among employees, we received feedback, with 60% expressing a desire to
      participate in the two proposed projects. Subsequently, we scheduled meetings with the social enterprise "Potter"
      as well as the community union "Ana-Bana." In the first phase, we listened to the needs, defined an action plan,
      and got to work.
    </p>

    <img src="../../../../assets/blog/pro-bono/img2.jpg" alt="" />

    <p>
      <b class="blue" style="font-size: 26px;">
        The community union "Ana-Bana" in Lagodekhi needed help in creating a reading space and library, for which,
        within the framework of TBC Leasing, we started collecting books. Additionally, we purchased dozens of books and
        handed them over together with our employees.
      </b>
    </p>

    <img src="../../../../assets/blog/pro-bono/img3.jpg" alt="" />

    <p>
      As for
      <b class="blue" style="font-size: 26px;">
        "Potteria" – the enterprise's social mission is to assist the reintegration of women who have been in conflict
        with the law and have experienced violence into society through acquiring new professions and employment in a
        creative workshop.
      </b>
    </p>

    <p>
      At this stage, their priority is to produce corporate offerings and increase sales, in which we actively engaged,
      and we also visited to participate in a master class.
    </p>

    <p>
      This is all for now, in the future, we will try to tell you more about these interesting initiatives and
      companies.
    </p>
  </div>
</ng-container>
